import { render, staticRenderFns } from "./ViewerDetail.vue?vue&type=template&id=25a1bfad&scoped=true&"
import script from "./ViewerDetail.vue?vue&type=script&lang=js&"
export * from "./ViewerDetail.vue?vue&type=script&lang=js&"
import style0 from "./ViewerDetail.vue?vue&type=style&index=0&id=25a1bfad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a1bfad",
  null
  
)

export default component.exports